function fixHeader() {
    var a = $('<a>').addClass('btn header-action small--hide').attr('href', '/pages/design-team-contact-form').html('Custom Design'),
        //aMobile = $('<a>').addClass('btn header-action-mobile').attr('href', '/pages/design-team-contact-form').html('Custom Design'),
        //navi = $("ul.site-nav.site-navigation"),
        //newrow = $("<div>").addClass('header-row'),
        //text = $("<span>Design Your Dream Interior</span>").appendTo(newrow),
        //p = $("#SiteHeader").append(newrow), // <a href="/pages/customization-design" class="btn">
        //wrapper = $("<div>").addClass('action-wrapper').prepend(newrow).append(a);
        //li = $("<li>").addClass('site-nav__item site-nav__expanded-item').append(a).appendTo(navi);
        sitenav = $(".header-item--icons .site-nav .site-nav__icons").prepend(a);
    //mobilenav = $(".mobile-nav").closest(".drawer__contents").find('.drawer__title');

    //aMobile.insertAfter(mobilenav);

    //mobilenav.append(aMobile);

    //p.addClass('top-action-button-holder');
}

//NOT USED
function fixHero() {
    var homehero = $("#shopify-section-template--15863069573303__slideshow_gJRcbe").addClass('boosted_hero'),
        slide1link = homehero.find('a.hero__slide-link'),
        h2 = homehero.find('h2'),
        link = slide1link.attr('href');

    slide1link.remove();

    h2.replaceWith("<h1 class='h1 hero__title'>" + h2.html() + "</h1>");
}

function fixh1logo() {
    var h1img = $('h1.site-header__logo');
    if (h1img.length) {
        h1img.replaceWith("<div class='site-header__logo'>" + h1img.html() + "</div>");
    }
}

//not used - fixed in template
function fixPromoGrids() {
    var promoGrid = $(".homepage-boosted-promo"),
        titles = promoGrid.find('.promo-grid__text .rte--strong'),
        subhead = promoGrid.find('.promo-grid__text .rte--em'),
        alinks = promoGrid.find('a.promo-grid__slide-link').remove();

    titles.each(function (index) {
        $(this).replaceWith("<h3 class='" + $(this).attr('class') + "'>" + $(this).html() + "</h3>");
    });

    subhead.each(function (index) {
        $(this).replaceWith("<h5 class='" + $(this).attr('class') + "'>" + $(this).html() + "</h5>");
    });


}
//no longer used - changed in template
function fixPromos() {
    var promos = $(".boosted-promo .flex-grid"),
        totalA = promos.find('a.promo-grid__slide-link').remove(),
        h2 = promos.find('h2.rte--block'),
        subheading = promos.find('.promo-grid__text div.rte--em');

    h2.each(function (index) {
        $(this).replaceWith("<h1 class='" + $(this).attr('class') + "'>" + $(this).html() + "</h1>");
    });

    subheading.each(function (index) {
        $(this).replaceWith("<h3 class='" + $(this).attr('class') + "'>" + $(this).html() + "</h3>");
    });

}

function fixFooterTag() {
    $(".footer-promotions h2.h3").each(function (index) {
        $(this).replaceWith("<div class='" + $(this).attr('class') + "'>" + $(this).html() + "</div>");
    });
}

function doCTAsOnHome() {
    var cta1 = $(".cta1"),
        shopifySection1 = cta1.closest('.index-section').addClass('offset-color cta1-section boosted-section'),
        section1 = cta1.closest('.section-header'),
        h21 = section1.find('h2').html('Personalize Your Living Space'),
        //headings = shopifySection1.find('.collection-item__title'),
        h41 = $("<h4 class='padd'>Explore the Timeless Elegance of Our Premium Rustic Furniture Collection</h4>").insertAfter(h21),

        //featured headings
        homeSectionFeature = $(".shopify-section .section-header .featured-products").closest('.shopify-section'),
        //headings2 = homeSectionFeature.find('.collection-item__title');

        //cta2 = $(".homepagecta-2"),
        //shouldbeh2 = cta2.find('.rte--strong'),

        //sofas and possibly others
        //sofaAndOthers = $(".boosted-promo.normal-size-promo"),
        //shouldbeh3 = sofaAndOthers.find('.promo-grid__text h1'),
        //shouldbeh5 = sofaAndOthers.find('.promo-grid__text h3'),

        jasonscott = $(".cta2-jason"),
        sectionJasonScott = jasonscott.closest('.index-section').addClass('offset-color-jason cta1-section boosted-section'),
        //sectionJson = jasonscott.closest('.section-header'),
        h2Jason = sectionJasonScott.find('h2'),//.html('Jason Scott Collection'),
        //jsonHeadings = sectionJasonScott.find('.collection-item__title'),
        h4Jason = $("<h4 class='padd'>Built To Last Generations</h4>").insertAfter(h2Jason);


    //shouldbeh3.each(function (index) {
    //    $(this).replaceWith("<h3 class='" + $(this).attr('class') + "'>" + $(this).html() + "</h3>");
    // });

    //shouldbeh5.each(function (index) {
    //     $(this).replaceWith("<h5 class='" + $(this).attr('class') + "'>" + $(this).html() + "</h5>");
    // });

    //jsonHeadings.each(function (index) {
    //   $(this).replaceWith("<h3 class='" + $(this).attr('class') + "'>" + $(this).html() + "</h3>");
    //});

    //headings.each(function (index) {
    //    $(this).replaceWith("<h3 class='" + $(this).attr('class') + "'>" + $(this).html() + "</h3>");
    //});

    //headings2.each(function (index) {
    //    $(this).replaceWith("<h3 class='" + $(this).attr('class') + "'>" + $(this).html() + "</h3>");
    //});

    // shouldbeh2.each(function (index) {
    //    $(this).replaceWith("<h2 class='" + $(this).attr('class') + "'>" + $(this).html() + "</h2>");
    // });
}

function fixPopup() {
    //hack into iframe since mailchimp doesn't allow custom css scripting
    var popupframe = $('iframe[data-dojo-attach-point="iframeModalContainer"]').addClass('boosted-iframe-popup');
    if (!popupframe.length) {
        setTimeout(fixPopup, 50);
        return;
    }
    //popupframe.css('height','100% !important');

    popupframe.parent().addClass('boosted-iframe-holder').closest('.mc-modal').addClass('boosted-mc-mobile');

    if ($(popupframe).contents() && $(popupframe).contents()[0] && $(popupframe).contents()[0].body) {
        doFixPopup($($(popupframe).contents()[0]));
        //popupframe.height('100%').parent().css('max-height','none').css('box-shadow','none');
        return;
    }
    popupframe.on('load',
        function () {
            doFixPopup($($(this).contents()[0]));
            // $(this).height('100%').parent().css('max-height','none').css('box-shadow','none');
        });
}

function doFixPopup(doc) {
    //var innerBody = doc.body,
    //imgSrc = 'https://runyonsfinefurniture.com/cdn/shop/files/Runyons_Fine_Furniture_Desktop_Hero_Image.jpg',
    //p = innerBody.find('.modalContent__image').show().css('background-image','url(' + imgSrc + ')'),
    var styles = `
            .modalContent{
                display: flex;
                justify-content: center;
                height: 100%;
                width: 100%;
                align-items: center;
                background:transparent;
            }

            .content__button input{
                background: #FFF;
                color: #000;
                text-transform: uppercase;
            }

            .modalContent__content form{
                width:100%;
            }
            
            .modalContent__content{
                position: relative;
                z-index: 2;
                height: 100%;
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                background: #00000069;
                border: 10px solid #f8f4ed;
            }

            .modalContent__image{
                position: absolute;
                top: 0;
                width: 100%;
                left: 0;
                height: 100%;
                box-sizing: content-box;
                display: flex;
                justify-content: center;
                align-items: center;
                background-image: url(https://runyonsfinefurniture.com/cdn/shop/files/19.jpg);
                filter: brightness(40%);
                z-index: -1;
            }

            .content__titleDescription h2, .content__titleDescription p, .content__formFields label{
                color:#FFF;
            }

            
            .modalContent--mobile .modalContent__content{
                height: 80%;
                width: 90%;
            }

            .boosted-popup-header{
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 20px 0px;
            }

            .boosted-popup-header img{
                width:100%;
                max-width: 300px;
            }
        `,
        logoSrc = 'https://runyonsfinefurniture.com/cdn/shop/files/logo-gold-large_400x_2x_df36da67-a590-466d-b541-6915d9114124.webp',
        logoImg = doc[0].createElement('img'),
        logoCont = doc[0].createElement('div'),
        styleSheet = doc[0].createElement("style");

    logoCont.className = 'content__titleDescription boosted-popup-header';
    logoImg.src = logoSrc;
    $(doc).find('.modalContent__content').prepend(logoCont);

    logoCont.append(logoImg);

    styleSheet.textContent = styles;
    $(doc).find('head').append(styleSheet);

    $(doc).find('.modalContent__image').appendTo($(doc).find('.modalContent__content'))

    console.log('added styles');
}

function manuallyLoadProductForm() {
    if (window.location.href.indexOf("/products/") > -1) {
        fetch('/pages/direct-product-form') // Make sure the URL is correct
            .then(response => response.text())
            .then(html => {
                // Parse the response HTML
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, 'text/html');
                let content = doc.querySelector('.shopify-app-block'); // Adjust based on the template structure

                window._loadedProductFormContent = content;
                if (window._docLoaded) {
                    insertProductFormContent();
                }
            })
            .catch(error => console.error('Error loading page content:', error));
    }
}

function insertProductFormContent() {
    // Check if content exists, then insert it into the container
    if (window._loadedProductFormContent) {
        var productSection = $('.page-content.page-content--product'),
            newP = productSection.find('.boosted-inqiure-holder'),//$("<div class='grid__item medium-up--one-third'></div>").appendTo(grid),
            bodyContent = newP.find('.boosted-inquire-content'),
            holder = bodyContent.find('.card-holder-body').remove();

        bodyContent.append(window._loadedProductFormContent);

        window._loadedProductFormContent = null;

        startFormTimer();
    }
}

function checkFormReadyToFix() {
    var form = $(".boosted-inquire-content form-embed");
    if (form && form.length) {
        form[0].shadowRoot.querySelectorAll("label, input").forEach(element => {
            element.style.textAlign = "left";
        });
        form[0].shadowRoot.querySelectorAll("input,textarea").forEach(element => {
            element.parentElement.style.marginBottom = "10px";
        });
    } else {
        startFormTimer();
    }
}

function startFormTimer() {
    window.setTimeout(function () {
        checkFormReadyToFix();
    }, 100);
}

function fixProductPage() {
    var productSection = $('.page-content.page-content--product');
    if (productSection && productSection.length) {
        var usingOtherForms = false;
        if (usingOtherForms) {
            //find have a question
            var blocks = productSection.find('.product-block.product-block--tab'),
                grid = productSection.find('.grid'),
                usingJotForm = false, // no longer using jotform - must manually load it in
                usingNativeForms = false,
                found = false,
                newP = productSection.find('.boosted-inqiure-holder'),//$("<div class='grid__item medium-up--one-third'></div>").appendTo(grid),
                bodyContent = newP.find('.boosted-inquire-content');//,
                //wrapper = $("<div class='boosted-inquire-wrapper'><div>").appendTo(newP),
                //header = $("<h3>Inquire about this Product</h3>").appendTo(wrapper),
                //msg = $("<h6>We are happy to help!</h6>").appendTo(wrapper),
                //holder = bodyContent.find('.card-holder-body').remove();

            for (var x = 0; x < blocks.length; x++) {
                var label = $(blocks[x]).find('button.label.collapsible-trigger').text().trim().toLowerCase();
                if (label === 'have a question?') {
                    found = true;

                    if (usingJotForm) {
                        content = $(blocks[x]).find('.collapsible-content').appendTo(bodyContent).css('transition', 'none')
                            .css('visibility', 'visible').css('opacity', '1').css('height', 'auto');

                    } else if (usingNativeForms) {
                        insertProductFormContent();
                    } else { //using call rail
                        insertCallRailForm(bodyContent);
                    }
                    $(blocks[x]).hide();
                    break;
                }
            }

            //if (!found && !usingJotForm) {
            //    insertProductFormContent();
            //}

            if (!found) {
                insertCallRailForm(bodyContent);
            }
        }

        //add warning about long lead times as requested by team
        var allProductBlocks = $(".boosted-data-product-blocks");
        if (allProductBlocks && allProductBlocks.length) {
            var newWarning = $("<div class='product-block'><div class='lead-times'>Some items may have long lead times. Please contact us for assistance.</div></div>").appendTo(allProductBlocks);
        }

        var longDescriptions = $(".product-block-meta-boosted"),
            normalDesc = $(".boosted-description"),
            normalDescText = normalDesc.text(),
            otherLongDesc = $(".description-boosted-long"),
            innerDesc = longDescriptions.find(".boosted-desc-long").length;



        for (x = 0; x < otherLongDesc.length; x++) {
            if (normalDescText && normalDescText.trim() !== $(otherLongDesc[x]).text().trim()) {
                $(otherLongDesc[x]).show();
            }
        }

        if (!innerDesc) {
            //haven't updated yet
            normalDesc.css('margin-bottom', '20px');
            return;
        }
        for (var x = 0; x < longDescriptions.length; x++) {
            var content = $(longDescriptions[x]);
            if (content.text().trim() === 'Text block') { //weird glitch poor programming
                //content.hide();
            }
            else if (content.find('.boosted-desc-long').length) {
                //found our block to move
                var addBtn = $("button.add-to-cart"),
                    quoteBtn = $(".request-quote-button"),
                    parent = quoteBtn.length ? quoteBtn.closest('.boosted-product-cont') : addBtn.closest('.boosted-product-cont'),
                    bestFor = parent.parent().find('.best-for-container'),
                    newWrapper = $('<div class="shopify-section alt-accent-section"><div class="index-section"><div class="page-width"><div class="custom-content"><div class="custom__item one-whole align--center">' +
                        '<div class="custom__item-inner custom__item-inner--liquid"><div class="rte"><div class="texthere"></div></div></div></div></div></div></div>');

                newWrapper.find('.texthere').append(content);
                //parent = quoteBtn.length ? quoteBtn.closest('.product-block') : addBtn.closest('.product-block').parent();

                //content.insertAfter(parent);

                //might be a best for container, we should put it after it if exists
                if (bestFor.length) {
                    newWrapper.insertAfter(bestFor);
                } else {
                    newWrapper.insertAfter(parent);
                }
                content.css('display', 'block');
            } else {
                content.css('display', 'block');
            }
        }

        //if(!found){
        //    return;
        //}
        // var gridItems = productSection.find(".grid__item").removeClass('medium-up--one-half').addClass('medium-up--one-third');

        //checkForProductRecFrameFix(productSection);
    }
}

function checkForProductRecFrameFix(productSection) {
    var recs = productSection.find('product-recommendations');
    if (recs && recs.length) {
        var parent = recs.closest('.product-block'),
            appendTo = recs.closest('.page-content--product');

        parent.insertAfter(appendTo);
    }

}


function fixFooter() {
    var footer = $(".site-footer").addClass('boosted-footer'),
        p = $(".site-footer .footer__logo"),
        getDirectionsLink = 'https://maps.google.com/?daddr=Runyon%27s%20Fine%20Furniture%20500%20North%20Hwy%20377%20Roanoke,%20Texas%2076262',
        getDirections = $('<a class="btn header-action" style="color:#000">Get Directions</a>').prop('href', getDirectionsLink),
        customDesign = $('<a class="btn header-action" style="color:#000" href="/pages/design-team-contact-form">Custom Design</a>').insertAfter(p),
        map = '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3346.016526143404!2d-97.23013228776881!3d33.0033397734596!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864dd0f8c5960e47%3A0x977c612d3d7068ee!2sRunyon&#39;s%20Fine%20Furniture!5e0!3m2!1sen!2sus!4v1732056524118!5m2!1sen!2sus" width="400" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
        //mapParent = $(".site-footer .map").closest('.footer__item-padding').append($(map)),
        mapParent = $(".site-footer .grid__item[data-type='custom']").find('.footer__item-padding').append($(map)),
        mapSectionHeader = mapParent.find('.footer__title').addClass('center-wrapper'),
        directionsWrap = $("<div class='center-wrapper'>").appendTo(mapParent);

    getDirections.appendTo(directionsWrap);

    jasonScottLinkBox = $('<div class="promo-grid__container vertical-center horizontal-center"><div class="promo-grid__bg"> <image-element data-aos="image-fade-in" class="aos-init aos-animate"> <img src="//runyonsfinefurniture.com/cdn/shop/files/jason-scott-console-2_e93ec29b-1f4d-4377-a461-a3bcb77935fa.png?v=1681961334&amp;width=2130" alt="Jason Scott Collection" srcset="//runyonsfinefurniture.com/cdn/shop/files/jason-scott-console-2_e93ec29b-1f4d-4377-a461-a3bcb77935fa.png?v=1681961334&amp;width=352 352w, //runyonsfinefurniture.com/cdn/shop/files/jason-scott-console-2_e93ec29b-1f4d-4377-a461-a3bcb77935fa.png?v=1681961334&amp;width=832 832w, //runyonsfinefurniture.com/cdn/shop/files/jason-scott-console-2_e93ec29b-1f4d-4377-a461-a3bcb77935fa.png?v=1681961334&amp;width=1200 1200w, //runyonsfinefurniture.com/cdn/shop/files/jason-scott-console-2_e93ec29b-1f4d-4377-a461-a3bcb77935fa.png?v=1681961334&amp;width=1920 1920w" loading="lazy" class="image-fit promo-grid__bg-image promo-grid__bg-image--5e781691-4499-4c66-a1a6-7bab98a3fc2b image-element" sizes="(min-width: 769px) 50vw, 100vw"> </image-element></div><div class="promo-grid__content"><div class="promo-grid__text"><h5 class="rte--block rte--em"> the complete collection</h5><h3 class="rte--block rte--strong">Jason Scott</h3><a href="/collections/jason-scott-collection" class="btn btn--inverse"> Shop Now</a></div></div></div>')
        .insertBefore(customDesign).addClass('boosted-footer-promo-grid');

}

function doMegaMenu() {
    var nav = $(".site-nav.site-navigation").addClass('boosted-menu'),
        imgWidth = 700,
        dropdowns = nav.find('li.site-nav--has-dropdown'),
        menuEnumOLD =
        {
            'living': { 'imgsrc3': 'https://runyonsfinefurniture.com/cdn/shop/files/bison-ridge-leather-swivel-chair-1.jpg', 'aitem3': '/collections/western-swivel-chairs', 'span3': "Western Swivel Chairs", 'imgsrc2': 'https://runyonsfinefurniture.com/cdn/shop/files/stitched-longhorn-leather-chair-1.jpg', 'aitem2': '/collections/western-accent-chairs', 'span2': "Western Accent Chairs", 'imgsrc1': 'https://runyonsfinefurniture.com/cdn/shop/products/high-end-sectional-sofa-4.jpg', 'aitem1': '/collections/western-sectional-sofas', 'span1': 'Western Sectionals', 'headertext': "All Western Living Room Furniture", 'headerprop': '/collections/western-living-room-furniture' },
            'dining': { 'imgsrc3': '', 'aitem3': '', 'span3': "", 'imgsrc2': '', 'aitem2': '', 'span2': "", 'imgsrc1': '', 'aitem1': '', 'span1': '', 'headertext': "", 'headerprop': '' },
            'bedroom': { 'imgsrc3': '', 'aitem3': '', 'span3': "", 'imgsrc2': '', 'aitem2': '', 'span2': "", 'imgsrc1': '', 'aitem1': '', 'span1': '', 'headertext': "", 'headerprop': '' },
            'office': { 'imgsrc3': '', 'aitem3': '', 'span3': "", 'imgsrc2': '', 'aitem2': '', 'span2': "", 'imgsrc1': '', 'aitem1': '', 'span1': '', 'headertext': "", 'headerprop': '' },
            'bar': { 'imgsrc3': '', 'aitem3': '', 'span3': "", 'imgsrc2': '', 'aitem2': '', 'span2': "", 'imgsrc1': '', 'aitem1': '', 'span1': '', 'headertext': "", 'headerprop': '' },
            'entertainment': { 'imgsrc3': '', 'aitem3': '', 'span3': "", 'imgsrc2': '', 'aitem2': '', 'span2': "", 'imgsrc1': '', 'aitem1': '', 'span1': '', 'headertext': "", 'headerprop': '' },
            'decor': { 'imgsrc3': '', 'aitem3': '', 'span3': "", 'imgsrc2': '', 'aitem2': '', 'span2': "", 'imgsrc1': '', 'aitem1': '', 'span1': '', 'headertext': "", 'headerprop': '' },
            'jason scott': { 'imgsrc3': '', 'aitem3': '', 'span3': "", 'imgsrc2': '', 'aitem2': '', 'span2': "", 'imgsrc1': '', 'aitem1': '', 'span1': '', 'headertext': "", 'headerprop': '' },
            'more': { 'imgsrc3': '', 'aitem3': '', 'span3': "", 'imgsrc2': '', 'aitem2': '', 'span2': "", 'imgsrc1': '', 'aitem1': '', 'span1': '', 'headertext': "", 'headerprop': '' }
        },
        menuEnum = {
            'living': {
                'imgsrc3': 'https://runyonsfinefurniture.com/cdn/shop/files/Speckled_Cowhide_Leather_Desk_Chair-3.jpg',
                'aitem3': '/collections/cowhide-chairs',
                'span3': "Cowhide Chairs",
                'imgsrc2': 'https://runyonsfinefurniture.com/cdn/shop/files/AmarilloRedStitchAccentChair_Ottoman-3.jpg',
                'aitem2': '/collections/western-accent-chairs',
                'span2': "Western Accent Chairs",
                'imgsrc1': 'https://runyonsfinefurniture.com/cdn/shop/products/santiago-western-sofa-sectional-1.jpg',
                'aitem1': '/collections/western-sectional-sofas',
                'span1': 'Western Sectionals',
                'headertext': "All Western Living Room Furniture",
                'headerprop': '/collections/western-living-room-furniture'
            },
            'dining': {
                'imgsrc3': 'https://runyonsfinefurniture.com/cdn/shop/files/stitched-longhorn-leather-chair-1.jpg',
                'aitem3': '/collections/western-dining-chairs',
                'span3': "Western Dining Chairs",
                'imgsrc2': 'https://runyonsfinefurniture.com/cdn/shop/products/jason-scott-dining-table-1.png',
                'aitem2': '/collections/western-dining-tables',
                'span2': "Western Dining Tables",
                'imgsrc1': 'https://runyonsfinefurniture.com/cdn/shop/files/old-world-style-genuine-heirloom-buffet-2_front_top_view.png',
                'aitem1': '/collections/western-buffets',
                'span1': "Western Buffets",
                'headertext': "All Western Dining Room Furniture",
                'headerprop': '/collections/western-dining-room-furniture'
            },
            'bedroom': {
                'imgsrc3': 'https://runyonsfinefurniture.com/cdn/shop/products/cb-avila-heirloom-chest-natural-caramel-1.jpg',
                'aitem3': '/collections/western-chests',
                'span3': "Western Chests & Nightstands",
                'imgsrc2': 'https://runyonsfinefurniture.com/cdn/shop/products/image_b9adcf31-1829-4893-abeb-9927db757125.png',
                'aitem2': '/collections/western-dressers',
                'span2': "Western Dressers",
                'imgsrc1': 'https://runyonsfinefurniture.com/cdn/shop/files/jason-scott-bed-and-antler-chandelier.png',
                'aitem1': '/collections/western-beds',
                'span1': "Western Beds",
                'headertext': "All Western Bedroom Furniture",
                'headerprop': '/collections/western-bedroom-furniture'
            }, //DONE updated up to here
            'office': {
                'imgsrc3': 'https://runyonsfinefurniture.com/cdn/shop/products/rodeo-architect-western-quilted-leather-desk-chair-1.jpg',
                'aitem3': '/collections/western-office-chairs',
                'span3': "Western Office Chairs",
                'imgsrc2': 'https://runyonsfinefurniture.com/cdn/shop/products/image_c87d3615-aea4-42eb-83c2-f7c5e46c9907.png',
                'aitem2': '/collections/western-bookcases',
                'span2': "Western Bookcases",
                'imgsrc1': 'https://runyonsfinefurniture.com/cdn/shop/products/salamanca-desk-1.jpg',
                'aitem1': '/collections/western-office-desks',
                'span1': "Western Office Desks",
                'headertext': "All Western Office Furniture",
                'headerprop': '/collections/western-office-furniture'
            },
            'bar': {
                'imgsrc3': 'https://runyonsfinefurniture.com/cdn/shop/products/parota-bar-table-1.jpg',
                'aitem3': '/collections/western-pub-tables',
                'span3': "Western Pub Tables",
                'imgsrc2': 'https://runyonsfinefurniture.com/cdn/shop/files/burnished-red-santa-fe-saddle-bar-stool-3.jpg',
                'aitem2': '/collections/western-saddle-stools',
                'span2': "Western Saddle Stools",
                'imgsrc1': 'https://runyonsfinefurniture.com/cdn/shop/products/adam-western-bar-stool-1.png',
                'aitem1': '/collections/western-bar-stools',
                'span1': "Western Bar Stools",
                'headertext': "All Western Bar Furniture",
                'headerprop': '/collections/western-bar-room'
            },
            'entertainment': {
                'imgsrc3': 'https://runyonsfinefurniture.com/cdn/shop/files/Brown_Croc_Leather_Game_Chair-2.jpg',
                'aitem3': 'https://runyonsfinefurniture.com/pages/design-team-contact-form',
                'span3': "Custom Design",
                'imgsrc2': 'https://runyonsfinefurniture.com/cdn/shop/products/image_485ae028-6d3d-42c4-9f52-5782ef87c303.png',
                'aitem2': '/collections/poker-game-tables',
                'span2': "Western Game Chairs",
                'imgsrc1': 'https://runyonsfinefurniture.com/cdn/shop/files/Brown_Croc_Leather_Game_Chair.jpg',
                'aitem1': '/collections/western-game-chairs',
                'span1': "Western Entertainment Centers",
                'headertext': "All Western Game Room Furniture",
                'headerprop': '/collections/western-game-room'
            },
            'decor': {
                'imgsrc3': 'https://runyonsfinefurniture.com/cdn/shop/files/Hello-Friend-1.jpg',
                'aitem3': '/collections/western-sculptures',
                'span3': "Western Sculptures",
                'imgsrc2': 'https://runyonsfinefurniture.com/cdn/shop/files/mountain-lodge-antler-table-lamp-2.png',
                'aitem2': '/collections/western-table-lamps',
                'span2': "Western Table Lamps",
                'imgsrc1': 'https://runyonsfinefurniture.com/cdn/shop/products/brindlepatchsq.jpg',
                'aitem1': '/collections/western-pillows',
                'span1': "Western Pillows",
                'headertext': "All Western Home Decor",
                'headerprop': '/collections/western-home-decor'
            },
            'jason scott': {
                'imgsrc3': 'https://runyonsfinefurniture.com/cdn/shop/products/60-inch-round-custom-teak-dining-table-1.jpg',
                'aitem3': '/collections/jason-scott-dining-tables',
                'span3': "Jason Scott Western Dining Tables",
                'imgsrc2': 'https://runyonsfinefurniture.com/cdn/shop/products/mr-bojangles-dresser-with-carving-dr-mr-crv.jpg',
                'aitem2': '/collections/jason-scott-dressers',
                'span2': "Jason Scott Dressers",
                'imgsrc1': 'https://runyonsfinefurniture.com/cdn/shop/products/jason-scott-colonial-bed-1.jpg',
                'aitem1': '/collections/jason-scott-beds',
                'span1': "Jason Scott Beds",
                'headertext': "All Jason Scott Collection",
                'headerprop': '/collections/jason-scott-collection'
            },
            'more': {
                'imgsrc3': 'https://runyonsfinefurniture.com/cdn/shop/files/home-office.jpg',
                'aitem3': '/blogs/everything-runyons',
                'span3': "Runyon's Blog",
                'imgsrc2': 'https://runyonsfinefurniture.com/cdn/shop/files/RusticGallioLeatherRecliner-1_1.jpg',
                'aitem2': '/collections/cowboy-christmas-2024',
                'span2': "Cowboy Christmas Collection",
                'imgsrc1': 'https://runyonsfinefurniture.com/cdn/shop/files/runyons-interior-design-10.png',
                'aitem1': '/pages/customization-design',
                'span1': "Custom Design",
                'headertext': "About Runyon's Fine Furniture",
                'headerprop': '/pages/about-us'
            },
            'lighting': {
                'imgsrc3': 'https://runyonsfinefurniture.com/cdn/shop/products/large-rustic-antler-chandelier-1.png',
                'aitem3': '/collections/chandeliers',
                'span3': "Chandeliers",
                'imgsrc2': 'https://runyonsfinefurniture.com/cdn/shop/files/Stag_Horn_Table_Lamp.png',
                'aitem2': '/collections/western-table-lamps',
                'span2': "Table Lamps",
                'imgsrc1': 'https://runyonsfinefurniture.com/cdn/shop/files/mountain-lodge-antler-floor-lamp.png',
                'aitem1': '/collections/western-floor-lamps',
                'span1': "Floor Lamps",
                'headertext': "All Lighting",
                'headerprop': '/collections/lighting'
            },
            'collections': {
                'imgsrc3': 'https://runyonsfinefurniture.com/cdn/shop/products/image_f04e91a8-47c0-41ef-ae65-8896021856b1.png',
                'aitem3': 'collections/nfr-2022-western-furniture',
                'span3': "NFR Collection",
                'imgsrc2': 'https://runyonsfinefurniture.com/cdn/shop/files/Speckled_Cowhide_Leather_Desk_Chair-3.jpg',
                'aitem2': '/collections/cowhide-chairs',
                'span2': "Cowhide Chairs",
                'imgsrc1': 'https://runyonsfinefurniture.com/cdn/shop/collections/Runyons-May-12-Scenes-WEB-99.jpg',
                'aitem1': '/collections/modern-ranch-furniture',
                'span1': "Modern Ranch Furniture",
                'headertext': "All Runyon's Collections",
                'headerprop': '/collections'
            }
        };

    for (var x = 0; x < dropdowns.length; x++) {
        var og = $(dropdowns[x]),
            name = og.find('details summary').text().toLowerCase().trim();
        if (!menuEnum[name]) {
            continue;
        }
        var wrap = $("<ul class='mega-menu-wrap'>"),
            menuli = $("<li class='mega-menu-li'>").appendTo(wrap),
            header = $("<a class='header-section'>").appendTo(menuli),
            existing = og.find('ul.site-nav__dropdown'),

            megaItem1 = $("<li class='mega-menu-li'>").appendTo(wrap),
            aItem1 = $("<a>").appendTo(megaItem1),
            aDiv1 = $("<div class='block-holder'>").appendTo(aItem1),
            img1 = $("<img>").appendTo(aDiv1).prop('loading', 'lazy'),
            span1 = $("<span>").appendTo(aDiv1),

            megaItem2 = $("<li class='mega-menu-li'>").appendTo(wrap),
            aItem2 = $("<a>").appendTo(megaItem2),
            aDiv2 = $("<div class='block-holder'>").appendTo(aItem2),
            img2 = $("<img>").appendTo(aDiv2).prop('loading', 'lazy'),
            span2 = $("<span>").appendTo(aDiv2),

            megaItem3 = $("<li class='mega-menu-li'>").appendTo(wrap),
            aItem3 = $("<a>").appendTo(megaItem3),
            aDiv3 = $("<div class='block-holder'>").appendTo(aItem3),
            img3 = $("<img>").appendTo(aDiv3).prop('loading', 'lazy'),
            span3 = $("<span>").appendTo(aDiv3),

            appendParent = existing.parent();

        og.css('position', 'static');

        existing.appendTo(menuli);
        wrap.appendTo(appendParent);

        header.html(menuEnum[name].headertext).prop('href', menuEnum[name].headerprop);

        span1.html(menuEnum[name].span1);
        aItem1.prop('href', menuEnum[name].aitem1);
        img1.prop('src', menuEnum[name].imgsrc1 + '?&width=' + imgWidth);

        span2.html(menuEnum[name].span2);
        aItem2.prop('href', menuEnum[name].aitem2);
        img2.prop('src', menuEnum[name].imgsrc2 + '?width=' + imgWidth);

        span3.html(menuEnum[name].span3);
        aItem3.prop('href', menuEnum[name].aitem3);
        img3.prop('src', menuEnum[name].imgsrc3 + '?width=' + imgWidth);

    }

    //speed up loading
    dropdowns.on('mouseenter', function () {
        $(this).find('img[loading="lazy"]').each(function () {
            $(this).removeAttr('loading');
            // Remove lazy loading
            // Reassign src to force load
            $(this).attr('src', $(this).attr('src'));
        });
    });
}


function fixCollectionScrollers() {
    //var scrollAmount = 350; // Distance to scroll per button click
    function updateButtons(cont) {
        var left = $(cont).find('.scrollLeft'),
            right = $(cont).find('.scrollRight');
        (cont.scrollLeft >= 0) ? left.show() : left.hide();
        (cont.scrollLeft + cont.clientWidth <= cont.scrollWidth) ? right.show() : right.hide();
    }

    function checkClickerView() {
        var clickers = $('.boosted-category-list .clickers'),
            container = $(".boosted-category-list .scrollbox-grid")[0];
        if (!container) {
            return;
        } else if (container.clientWidth === container.scrollWidth) {
            clickers.hide();
        } else {
            clickers.show();
        }
    }


    var collections = $('.boosted-category-list')
        .each(function () {
            var scrollContainer = $(this).find('.grid.grid--uniform').addClass('showblock')[0],
                scrollers = $("<div class='clickers'>").appendTo(scrollContainer),
                newContainer = $("<div class='scrollbox-grid'>").appendTo(scrollContainer),
                fadebars = $("<div class='fade-bars'>").appendTo(scrollContainer),
                fadeLeft = $("<div class='fade-left'>").appendTo(fadebars),
                fadeRight = $("<div class='fade-right'>").appendTo(fadebars),
                items = $(this).find('.grid__item').appendTo(newContainer),
                scrollAmount = items.length ? $(items[0]).width() : 300,
                scrollerLeft = $("<div class='scrollButtonBL scrollLeft'>").appendTo(scrollers)
                    .click(newContainer, function (e) {
                        var container = e.data,
                            scrollTotal = container[0].scrollLeft;
                        if (scrollTotal - scrollAmount < 0) {
                            container[0].scrollBy({ left: -scrollTotal, behavior: "smooth" });
                        } else {
                            container[0].scrollBy({ left: -scrollAmount, behavior: "smooth" });
                        }
                    }),
                scrollerRight = $("<div class='scrollButtonBL scrollRight'>").appendTo(scrollers)
                    .click(newContainer, function (e) {
                        var container = e.data,
                            scrollTotal = container[0].clientWidth + container[0].scrollLeft;
                        if (scrollTotal + scrollAmount > container[0].scrollWidth) {
                            container[0].scrollBy({ left: (container[0].scrollWidth - scrollTotal), behavior: "smooth" });
                        } else {
                            container[0].scrollBy({ left: scrollAmount, behavior: "smooth" });
                        }
                        //updateButtons(container);
                    });

        });

    $(window).resize(function () {
        checkClickerView();
    });
    checkClickerView();
}

function doScrollActionForGrid() {
    $(".scroll-action-collection").each(function () {
        $(this).on("click", function (e) {
            e.preventDefault();
            $('html').animate({
                scrollTop: $(".collection-content").offset().top
            }, 500); // 600ms animation
        });
    });

}

function doJasonScottToggle() {
    var toggle = $("#request-quote-button").on('click', function () {
        $("#quote-form").show();
    });
}

function doShippingBarObserver() {

    var link = 'https://runyonsfinefurniture.com/policies/shipping-policy';

    $('#bear-shipping-temp').click(function () {
        window.location.href = link;
    });

    function doInnerObserver(pElement) {
        var selector = '.conversion-bear-money',
            observer2 = new MutationObserver(function (mutations) {
                for (var i = 0; i < mutations.length; i++) {
                    var nodes = mutations[i].addedNodes;
                    for (var j = 0; j < nodes.length; j++) {
                        var node = nodes[j];
                        if ($(node).find(selector).length) {
                            var p = $("#SiteHeader");
                            console.log("found inner shipping bar - clean up");
                            $('#bear-shipping-temp').remove();
                            $('#cb-shipping-bar').show().prependTo(p)
                                .click(function () {
                                    window.location.href = link;
                                });
                            observer2.disconnect();
                            hideBar();
                            return;
                        }
                    }
                }
            });

        observer2.observe(pElement, {
            childList: true,
            subtree: true
        });


    }


    var selector = 'cb-shipping-bar',
        observer = new MutationObserver(function (mutations) {
            for (var i = 0; i < mutations.length; i++) {
                var nodes = mutations[i].addedNodes;
                for (var j = 0; j < nodes.length; j++) {
                    var node = nodes[j];
                    if (node.id === selector) {
                        console.log("found bear shipping bar");
                        //$('#bear-shipping-temp').remove();
                        doInnerObserver(node);
                        observer.disconnect();
                        return;
                    }
                }
            }
        });

    observer.observe(document.body, {
        childList: true,
        subtree: false
    });

    //hide when they close the bar
    function hideBar() {
        const target = document.querySelector("#cb-shipping-bar .cbShippingFixed");

        if (target && target.parentNode) {
            const parent = target.parentNode;

            const observer3 = new MutationObserver(() => {
                const stillExists = document.querySelector("#cb-shipping-bar .cbShippingFixed");
                if (!stillExists) {
                    $("#cb-shipping-bar").hide();
                    var h = $("#StickyHeaderWrap").height();
                    $("#StickyHeaderWrap").height((h - 45) + 'px');
                    observer3.disconnect();
                }
            });

            observer3.observe(parent, {
                childList: true
            });
        }

    }
}


function resetFormObservation(form) {
    var $f = $(form);

    //reset spam field
    $f.find('.potential-spam').val('No');

    $f[0]._watcher = {
        mousedown: 0,
        mouseup: 0,
        click: 0,
        keydown: 0,
        keyup: 0,
        country: 0, //0 unset, 1 bad, 2 good
        keypress: 0,
        change: 0,
        input: 0,
        touchstart: 0,
        touchend: 0,
        didPasteOnNote: 0,
        lastInputTime: new Date().valueOf(),
        intervals: [],
        total: 0,
        fresh: 1,
        minTotalEvents: 15
    };

    const eventList = ['mousedown', 'mouseup', 'click', 'keydown', 'keyup', 'keypress', 'touchstart', 'input', 'touchend'];

    $f.find('input, textarea').on(eventList.join(' '), function (e) {
        const type = e.type;
        if ($f[0]._watcher.hasOwnProperty(type)) {
            $f[0]._watcher[type]++;
            $f[0]._watcher.total++;

            if (type === 'input') {
                this.setCustomValidity("");
                //skip first interaction due to initial delay
                var now = new Date().valueOf(),
                    start = $f[0]._watcher.lastInputTime;
                $f[0]._watcher.intervals.push(now - start);

                $f[0]._watcher.lastInputTime = now;


                if (false) {
                    var intervals = $f[0]._watcher.intervals;
                    const avg = intervals.reduce((a, b) => a + b, 0) / intervals.length;
                    const variance = Math.max(...intervals) - Math.min(...intervals);
                    //console.log("average ", avg, ' variance', variance);

                    var avgSpamAdd = avg < 30 ? 4 : avg < 50 ? 3 : avg < 70 ? 2 : avg < 100 ? 1 : 0,
                        varianceSpamAdd = variance < 10 ? 4 : variance < 20 ? 3 : variance < 50 ? 2 : avg < 100 ? 1 : 0,
                        spamScore = varianceSpamAdd + avgSpamAdd;

                    console.log("average ", avg, ' variance', variance, ' spam score', spamScore);
                }
            }

        }

        //console.log(type);
        //console.log( $f[0]._watcher.total);
        // console.log( $f[0]._watcher);
    });

    $f.find('textarea, input').on('paste', function (e) {
        $f[0]._watcher.didPasteOnNote++;
        console.log("paste detected");
    });

    fetch("https://ipapi.co/json/")
        .then(res => res.json())
        .then(data => {
            var good = ["US", "CA", "MX"].includes(data.country);
            $f[0]._watcher.country = good ? 2 : 1;
            $f[0]._watcher.IP = data.ip;
        });

}

function createDynamicForm(containerId, formName) {

    let interacted = false,
        checkboxLabel = (containerId + "-checkbox"),
        start = Date.now();
    $(document).on('mousemove touchstart focusin', () => interacted = true);

    const $container = $('#' + containerId).addClass('bl-custom-form-wrapper');

    const $form = $('<form>', {
        id: formName.replace(/\s+/g, '-').toLowerCase(),
        class: 'bl-custom-form',
        name: formName
    });

    const addField = (labelText, inputOptions, hidden) => {
        var $wrapper = $("<div class='form-el'>").appendTo($form)
            .append($('<label>').text(labelText))
            .append($('<input>', inputOptions));
        if (hidden) {
            $wrapper.addClass('abs');
        }
    };

    // Name
    addField("Your Name", {
        type: 'text',
        name: 'your_name',
        class: 'bl-form-field full-width',
        required: true
    });

    // Email
    addField("Email Address", {
        type: 'email',
        class: 'bl-form-field full-width',
        name: 'email_address',
        required: true
    });

    // Phone
    addField("Phone Number", {
        type: 'tel',
        class: 'bl-form-field full-width',
        name: 'phone_number',
        required: true
    });

    // SMS consent checkbox
    $form.append($('<input type="hidden" name="Texting consent?" class="sms-consent-hidden" value="no"></input>'));


    $form.append(
        $('<input>', {
            type: 'checkbox',
            id: checkboxLabel,
            class: 'bl-form-field consent-checkbox',
            name: 'consent-checkbox-proxy'
        })
    );

    $form.append($('<label>').css('display', 'inline').html('I consent to receive text messages from this business').prop('for', checkboxLabel));

    //potential spam?
    addField("Potential Spam", {
        type: 'text',
        id: 'potential-checker',
        class: 'potential-spam',
        name: 'Potential Spam',
        autocomplete: 'off',
        tabindex: '-1'
    }, true);

    //recaptcha
    $form.append($('<input type="hidden" name="recaptcha-token" class="recaptcha-token"></input>'));

    //honeypot
    addField("Your Favorite Color", {
        type: 'text',
        id: 'color_field',
        name: 'your_favorite_color',
        autocomplete: 'off',
        tabindex: '-1'
    }, true);

    // Message (optional)
    $form.append($('<label>').text("Message"));
    $form.append($('<textarea>', {
        name: 'message',
        class: 'bl-form-field full-width message-area',
        rows: 5
    }));

    // Submit button
    const $button = $('<button>', {
        type: 'submit',
        class: 'btn',
        disabled: true,
        text: 'Submit'
    });

    $button[0]._originalClick = $button[0].click;

    $button[0].click = function () { };

    const $overlay = $("<div class='button-overlay'>")

    const $wrapper = $('<div>', {
        class: 'submit-wrapper'
    }).append($button).append($overlay).appendTo($form);

    // Thank-you message div (initially hidden)
    const $thankYou = $('<div>', {
        text: "Thanks for contacting us! We'll be in touch shortly.",
        class: 'thank-you-form',
        id: formName.replace(/\s+/g, '-').toLowerCase() + '-thank-you'
    });

    //spinner (initially hidden)
    const $formSpinner = $('<div class="form-loading-overlay" style="display: none;"><div class="spinner"></div></div>');

    resetFormObservation($form[0]);

    $overlay.on('click', function (e) {

        var form = $(this).closest('form'),
            note = form.find('textarea.message-area'),
            msg = note.val(),
            spinner = $(this).closest('.bl-html-form-holder').find('.form-loading-overlay'),
            IP = form[0]._watcher.IP;


        function doPreSubmit() {

            function checkCallbacks() {
                if (waiting.recaptcha && waiting.openai) {
                    //proceed ?
                    var blockSubmit = false,
                        tellUserAboutFormMsg = false;
                    console.log("got both responses: ", waiting);

                    //RECAPTCHA
                    if (waiting.recaptcha.failed) {
                        //didn't get a good reply, but we got a reply
                    } else if (waiting.recaptcha.verified) {
                        //console.log('Verification passed for recaptcha!');
                    } else {
                        console.log('blocking submit due to recaptcha... also block IP');
                        if (IP) {
                            blockIp(IP);
                        }
                        blockSubmit = true;
                    }
                    form.find('.recaptcha-token').val('');
                    //end recaptcha checks and reset

                    //OPENAI
                    if (waiting.openai.failed) {
                        //didn't get a good reply, but we got a reply
                    } else if (!waiting.openai.spam) {
                        //console.log('Verification passed for openai!');
                    } else {
                        console.log('blocking submit due to openai spam detection...need more detail');
                        tellUserAboutFormMsg = true;
                        blockSubmit = true;
                    }
                    //END openai checks and resets

                    //added 8/1/25 still pass - requested to ignore response
                    if (true) {
                        if (blockSubmit) {
                            form.find('.potential-spam').val('Yes');
                            blockSubmit = false;
                        }
                    }

                    if (blockSubmit) {
                        if (tellUserAboutFormMsg) {
                            spinner.hide();
                            note[0].setCustomValidity("Please enter a more detailed message.");
                            note[0].reportValidity();
                        }
                        //keep spinner up make them wonder...
                    } else {
                        //FINALLY go
                        doSubmitForm();
                        spinner.hide();
                    }
                }
            }

            var waiting = { 'recaptcha': null, 'openai': null };
            spinner.show();

            //RECAPTCHA test
            grecaptcha.enterprise.ready(function () {
                grecaptcha.enterprise.execute('6LfSE1UrAAAAAEe2fi50Bve7c4OIpKK9D7exaAdU', { action: 'submit' }).then(function (token) {
                    // Put the token in the hidden input
                    form.find('.recaptcha-token').val(token);

                    const formData = new FormData(form[0]);

                    // Now send POST request to your PHP backend
                    fetch('https://boostedlab.com/verify-recaptcha.php', {
                        method: 'POST',
                        body: formData,
                    })
                        .then(response => response.json())
                        .then(data => {
                            //spinner.hide();
                            console.log('Server verification response:', data);
                            waiting.recaptcha = data;
                            checkCallbacks();
                            if (data.verified) {
                                console.log('Recaptcha Verification passed!');
                                //form.find('.recaptcha-token').val('');
                                //doSubmitForm();
                                // e.target.submit(); // Optionally submit the form for real
                            } else {
                                console.log('Recaptcha Verification failed.');
                                //if (IP) {
                                //    blockIp(IP);
                                //}
                            }
                        })
                        .catch(error => {
                            console.error('Error verifying token:', error);
                            waiting.recaptcha = { 'failed': true };
                            checkCallbacks();
                            //spinner.hide();
                            //alert('An error occurred during verification.');
                        });
                });
            });

            if (msg) {
                //OPENAI test
                fetch('https://boostedlab.com/spam-check-openai.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams({ message: msg })
                })
                    .then(res => res.json())
                    .then(data => {
                        var rsp = data.verdict ? data.verdict.toLowerCase() : '';
                        rsp = rsp.trim();
                        if (rsp.includes('legit')) {
                            //  Good to go — submit form or proceed
                            console.log("PASSED - not spam");
                            waiting.openai = { 'spam': false };
                        } else if (rsp.indexOf('spam') === 0) {
                            //alert('Your message was flagged as spam. Please revise and try again.');
                            console.log("spam! go die");
                            waiting.openai = { 'spam': true };
                        } else {
                            //error of some kind
                            console.error("Something errored out during openai check");
                            waiting.openai = { 'failed': true };
                        }

                        console.log(data);

                        checkCallbacks();
                    })
                    .catch(error => {
                        console.error('Spam check failed:', error);
                        waiting.openai = { 'failed': true };
                        checkCallbacks();
                        //alert('There was a problem checking your message. Please try again.');
                    });
            } else {
                //don't check if there's no message to check...
                waiting.openai = { 'spam': false };
                checkCallbacks();
            }
        }

        function doSubmitForm() {
            setTimeout(() => {
                var button = form.find('.btn');
                button.prop('disabled', false);
                button[0]._originalClick();
                button.prop('disabled', true);
            }, 5);
        }

        function blockIp(ip) {
            let blocked = JSON.parse(sessionStorage.getItem('blockedIps') || '[]');
            if (!blocked.includes(ip)) {
                blocked.push(ip);
                sessionStorage.setItem('blockedIps', JSON.stringify(blocked));
            }
        }

        // To check if IP is blocked:
        function isIpBlocked(ip) {
            let blocked = JSON.parse(sessionStorage.getItem('blockedIps') || '[]');
            return blocked.includes(ip);
        }
        //if (this._doingSubmit) {
        //    return;
        //}

        if (!form[0].checkValidity()) {
            e.preventDefault();       // Stops normal submit
            e.stopImmediatePropagation(); // Blocks other listeners, including CallRail
            form[0].reportValidity();    // Triggers native validation UI
            return false;
        }

        if (IP && isIpBlocked(IP)) {
            e.preventDefault();       // Stops normal submit
            e.stopImmediatePropagation(); // Blocks other listeners, including CallRail
            form[0].reportValidity();    // Triggers native validation UI
            return false;
        }

        var honeypot = form.find('#color_field').val(),
            now = new Date(),
            //phrases = [
            //    "I would love to hear from you",
            //    "please contact me",
            //   "I am interested in",
            //    "is this still available",
            //    "looking forward to hearing",
            //    "I saw your ad",
            //     "your services"
            //],
            delta = now.valueOf() - start.valueOf(),
            note = form.find('textarea.message-area'),
            msg = note.val(),
            //msgLooksLikeSpam = /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{80,}$/.test(msg),
            wordsInMsg = msg.split(' '),
            //hasGclid = window.location.href.toLowerCase().includes('gclid='),
            //countryChecker = form[0]._watcher.country,
            //countryBad = countryChecker === 1 && hasGclid,
            intervals = form[0]._watcher.intervals,
            avg = intervals.reduce((a, b) => a + b, 0) / intervals.length,
            variance = Math.max(...intervals) - Math.min(...intervals),
            avgTooLow = avg < 30, //30ms is super fast!!!
            varianceTooLow = variance < 10; //something really fishy going on here
        //usedPaste = form[0]._watcher.didPasteOnNote,
        //suspicious = msg.length ? phrases.filter(p => msg.toLowerCase().includes(p.toLowerCase())).length : 0,
        //avgSpamAdd = avg < 50 ? 4 : avg < 70 ? 3 : avg < 90 ? 2 : avg < 110 ? 1 : 0,
        //varianceSpamAdd = variance < 20 ? 4 : variance < 40 ? 3 : variance < 60 ? 2 : avg < 100 ? 1 : 0,
        //spamScore = usedPaste + varianceSpamAdd + avgSpamAdd;// + suspicious;

        if (msg && msg.length && wordsInMsg.length < 2) {
            //need more words 
            note[0].setCustomValidity("Please enter a more detailed message.");
            note[0].reportValidity();
            e.preventDefault();
            //alert(honeypot);
            e.stopImmediatePropagation();
            return false;
        }

        //if (intervals.length < 5) {
        //typed less than 5 chars, cannot reliably use the typed data
        //    spamScore = usedPaste;
        //}

        //console.log("average ", avg, ' variance', variance, ' spam score', spamScore);
        //console.log("average ", avg, ' variance', variance);
        //textFillWrong = form[0]._watcher.textarea > 0 ? (msg.length !== form[0]._watcher.textarea) : false;

        if (honeypot || avgTooLow || varianceTooLow || !interacted || delta < 3000 || form[0]._watcher.total < form[0]._watcher.minTotalEvents) {
            //console.warn('Bot detected — submission blocked.');
            //if (IP) {
            //    blockIp(IP);
            //}
            e.preventDefault();
            //alert(honeypot);
            e.stopImmediatePropagation();
            return false;
        }

        //$(this).find('.newCheckbox').remove();
        //clean old checkbox if there is any
        const isChecked = form.find('.consent-checkbox').is(':checked');
        form.find('.sms-consent-hidden').val(isChecked ? 'yes' : 'no');
        form.find('.consent-checkbox')[0].checked = false;

        var haveValue = form.find('.message-area').val(),
            button = form.find('.btn');
        if (!haveValue) {
            form.find('.message-area').val(' ');
        }
        //DO SUBMIT
        doPreSubmit();
        //doSubmitForm();
    });

    $form.on('submit', function (e) {
        //stop page from refreshing
        e.preventDefault();

        // Show thank-you message
        $thankYou.fadeIn();

        //send event up 
        window.dataLayer.push({ event: 'formSubmissionSuccess-' + this.id });

        // Auto-hide after 20 seconds
        setTimeout(() => {
            $thankYou.fadeOut();
        }, 20000);

        setTimeout(() => {
            this.reset();
            resetFormObservation(this);
            interacted = false;
            start = Date.now();
            //$(this).find('.newCheckbox').remove();
        }, 5);
    });

    // Inject form and thank-you into the container
    $container.empty().append($form, $thankYou, $formSpinner);

    //remove button temporarily
}

function collapsePromoTextForMobile() {
    var items = $(".boosted-promo .promo-grid__text div.rte--block")
        .each(function () {
            if ($(this).hasClass('clamp') || $(this).text().length < 300) {
                return;
            }
            var self = this,
                toggle = $("<div class='read-more-cont'><a class='read-more-btn btn'>Read more</a></div>").insertAfter(this).click(function () {
                    $(self).toggleClass('clamp');
                    $(this).find('a').html($(self).hasClass('clamp') ? "Read More" : "Read Less");
                });
            $(this).addClass('clamp');
        });
}

function collapseFeaturedTextForMobile() {
    var items = $(".boosted-category-list .bottom-text.extra-bottom")
        .each(function () {
            if ($(this).hasClass('clamp') || $(this).text().length < 300) {
                return;
            }
            var self = this,
                toggle = $("<div class='read-more-cont'><a class='read-more-btn btn'>Read more</a></div>").insertAfter(this).click(function () {
                    $(self).toggleClass('clamp');
                    $(this).find('a').html($(self).hasClass('clamp') ? "Read More" : "Read Less");
                });
            $(this).addClass('clamp');
        });
}


function fixJotFormHeights() {
    var savedHeights = {};

    function alsoRemovePlacer(id){
        var placer = '.jotform-removeme';
        document.querySelectorAll(placer + ".my-" + id).forEach(el => el.remove());
    }

    window.addEventListener('message', function (e) {
        if (typeof e.data !== 'string') return;
        var args = e.data.split(':');
        if (args[0] === 'setHeight') {
            var formId = args[2];
            var height = args[1] + 'px';
            document.querySelectorAll('iframe[src*="' + formId + '"]').forEach(function (iframe, i) {
                var key = formId + '-' + i;
                savedHeights[key] = height;
                iframe.dataset.jotKey = key;
                iframe.style.setProperty('height', height, 'important');
                alsoRemovePlacer(formId);
            });
        }
    });

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
            var iframe = m.target;
            var key = iframe.dataset.jotKey;
            if (key && savedHeights[key] && iframe.style.height !== savedHeights[key]) {
                iframe.style.setProperty('height', savedHeights[key], 'important');
            }
        });
    });

    var checkExist = setInterval(function () {
        var iframes = document.querySelectorAll('iframe[src*="jotform.com"]');
        if (iframes.length) {
            clearInterval(checkExist);
            iframes.forEach(function (iframe) {
                observer.observe(iframe, { attributes: true, attributeFilter: ['style'] });
            });
        }
    }, 100);
}



$(function () {
    window._docLoaded = true;

    doScrollActionForGrid();

    //fixHeader();

    //fixHero();

    //fixh1logo();

    //fixPromos();

    fixFooterTag();

    //doCTAsOnHome();

    //fixPromoGrids();

    //fixPopup();

    //fixProductPage();

    //collapsePromoTextForMobile(); --added this code to the template instead

    fixFooter();

    fixCollectionScrollers();

    doMegaMenu();

    //doShippingBarObserver();

    doJasonScottToggle();

    window._allLoaded = true;
});

//manuallyLoadProductForm();

/* ══════════════════════════════════════════════════════════════════════
   NFR · COWBOY CHRISTMAS 2026  (boostedlab)
   Paste at the END of boosted-scripts.js. Plain JS, no jQuery needed.

   Shared by the homepage banner and /pages/cowboy-christmas:
     1. NFR.event   the only place the show dates live
     2. Countdown   fills every [data-nfr-countdown] on the page
     3. Tracking    one listener for every [data-nfr-track] click and
                    [data-nfr-view] impression, sent to the GTM dataLayer
                    and to Shopify customer events (for custom pixels)

   Next year: change NFR.event and everything follows.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
    "use strict";

    var NFR = (window.NFR = window.NFR || {});

    /* ── 1. Event ───────────────────────────────────────────────────── */
    NFR.event = {
        name: "Cowboy Christmas 2026",
        start: "2026-12-03T09:00:00-08:00", // doors open, day one (Pacific)
        end: "2026-12-12T16:00:00-08:00",   // doors close, last day
        openHour: 9,                        // daily hours, Pacific
        closeHour: 16,
        timeZone: "America/Los_Angeles",
        booth: "3145"
    };

    var START = Date.parse(NFR.event.start);
    var END = Date.parse(NFR.event.end);
    var DAY = 864e5;
    var FIRST_DAY = utcDay(NFR.event.start);
    var TOTAL_DAYS = (utcDay(NFR.event.end) - FIRST_DAY) / DAY + 1;

    function utcDay(iso) {
        var p = iso.slice(0, 10).split("-");
        return Date.UTC(+p[0], p[1] - 1, +p[2]);
    }

    // Calendar date and hour at the venue, whatever the visitor's own zone.
    var ptFormat;
    try {
        ptFormat = new Intl.DateTimeFormat("en-US", {
            timeZone: NFR.event.timeZone, hourCycle: "h23",
            year: "numeric", month: "numeric", day: "numeric", hour: "numeric"
        });
    } catch (e) { ptFormat = null; }

    function venueClock(now) {
        if (ptFormat && ptFormat.formatToParts) {
            var o = {};
            ptFormat.formatToParts(new Date(now)).forEach(function (p) { o[p.type] = +p.value; });
            return { day: Date.UTC(o.year, o.month - 1, o.day), hour: o.hour % 24 };
        }
        var d = new Date(now - 8 * 36e5); // fallback: PST, correct for December
        return { day: Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()), hour: d.getUTCHours() };
    }

    // before | open | opens-today | opens-tomorrow | after
    NFR.phase = function (now) {
        now = now || Date.now();
        if (now < START) return { phase: "before", ms: START - now };
        if (now >= END) return { phase: "after" };
        var v = venueClock(now);
        var day = Math.round((v.day - FIRST_DAY) / DAY) + 1;
        if (v.hour < NFR.event.openHour) return { phase: "opens-today", day: day };
        if (v.hour >= NFR.event.closeHour) return { phase: "opens-tomorrow", day: day + 1 };
        return { phase: "open", day: day };
    };

    // Set before first paint (this file loads in <head>), so CSS can hide
    // [data-nfr-hide-after] once the show is over without a flash.
    document.documentElement.setAttribute("data-nfr-phase", NFR.phase().phase);

    /* ── 2. Countdown ───────────────────────────────────────────────── */
    // Markup:  <div class="nfr-cd" data-nfr-countdown>Dec 3–12, 2026</div>
    // Options: data-nfr-label  heading shown before the show ("Doors open in")
    //          data-nfr-after  text shown once the show has closed
    // Any element with [data-nfr-hide-after] is hidden once the show closes.
    var UNITS = [["d", "Day", "Days"], ["h", "Hour", "Hours"], ["m", "Minute", "Minutes"], ["s", "Second", "Seconds"]];
    var SHORT = { d: "Days", h: "Hrs", m: "Min", s: "Sec" };
    var clocks = [];
    var timer = null;

    function el(tag, cls, text) {
        var n = document.createElement(tag);
        if (cls) n.className = cls;
        if (text != null) n.textContent = text;
        return n;
    }

    function build(root) {
        if (root.__nfr) return;
        var label = root.getAttribute("data-nfr-label") || "Doors open in";
        root.textContent = "";
        root.classList.add("nfr-cd");

        var sr = el("span", "nfr-cd__sr");
        var head = el("p", "nfr-cd__label", label);
        var clock = el("div", "nfr-cd__clock");
        clock.setAttribute("aria-hidden", "true");
        var nums = {};
        UNITS.forEach(function (u, i) {
            if (i) clock.appendChild(el("span", "nfr-cd__sep"));
            var unit = el("span", "nfr-cd__unit nfr-cd__unit--" + u[0]);
            nums[u[0]] = el("span", "nfr-cd__num", "00");
            var lab = el("span", "nfr-cd__lab");
            lab.appendChild(el("span", "nfr-cd__lab-full", u[2]));
            lab.appendChild(el("span", "nfr-cd__lab-short", SHORT[u[0]]));
            unit.appendChild(nums[u[0]]);
            unit.appendChild(lab);
            clock.appendChild(unit);
        });
        var live = el("div", "nfr-cd__live");
        var liveHead = el("p", "nfr-cd__live-head");
        liveHead.appendChild(el("span", "nfr-cd__dot"));
        var liveText = el("span", "nfr-cd__live-text");
        liveHead.appendChild(liveText);
        var liveSub = el("p", "nfr-cd__live-sub");
        live.appendChild(liveHead);
        live.appendChild(liveSub);

        [sr, head, clock, live].forEach(function (n) { root.appendChild(n); });
        root.__nfr = { label: label, sr: sr, head: head, clock: clock, nums: nums, live: live, liveText: liveText, liveSub: liveSub, last: {}, srAt: 0 };
        clocks.push(root);
    }

    function pad(n) { return (n < 10 ? "0" : "") + n; }

    function render(root, st, now) {
        var c = root.__nfr;
        if (root.getAttribute("data-phase") !== st.phase) {
            root.setAttribute("data-phase", st.phase);
            c.last = {};
            c.srAt = 0;
        }

        if (st.phase === "before") {
            var t = Math.floor(st.ms / 1000);
            var v = { d: Math.floor(t / 86400), h: Math.floor(t % 86400 / 3600), m: Math.floor(t % 3600 / 60), s: t % 60 };
            UNITS.forEach(function (u) {
                var k = u[0], txt = pad(v[k]);
                if (c.last[k] === txt) return;
                c.nums[k].textContent = txt;
                if (c.last[k] !== undefined) {
                    c.nums[k].classList.remove("is-tick");
                    void c.nums[k].offsetWidth; // restart the animation
                    c.nums[k].classList.add("is-tick");
                }
                c.last[k] = txt;
            });
            // Screen readers get a calm sentence, refreshed once a minute.
            if (now - c.srAt > 59e3) {
                c.sr.textContent = NFR.event.name + " opens in " + v.d + " " + (v.d === 1 ? "day" : "days") + ", " +
                    v.h + " " + (v.h === 1 ? "hour" : "hours") + " and " + v.m + " " + (v.m === 1 ? "minute" : "minutes") + ".";
                c.srAt = now;
            }
            return;
        }

        var booth = "Booth " + NFR.event.booth;
        if (st.phase === "after") {
            c.liveText.textContent = root.getAttribute("data-nfr-after") || "Thank you, Las Vegas";
            c.liveSub.textContent = "See you at Cowboy Christmas next year";
        } else if (st.phase === "open") {
            c.liveText.textContent = "Open now";
            c.liveSub.textContent = "Day " + st.day + " of " + TOTAL_DAYS + " · " + booth + " · until 4 p.m. PT";
        } else if (st.phase === "opens-today") {
            c.liveText.textContent = "Opens today at 9 a.m.";
            c.liveSub.textContent = "Day " + st.day + " of " + TOTAL_DAYS + " · " + booth + " · Pacific time";
        } else {
            c.liveText.textContent = "Opens tomorrow at 9 a.m.";
            c.liveSub.textContent = "Day " + st.day + " of " + TOTAL_DAYS + " · " + booth + " · Pacific time";
        }
        c.sr.textContent = (c.liveText.textContent + ". " + c.liveSub.textContent + ".").replace(/\.\./g, ".");
    }

    // Ticks every second while counting down, every 30 seconds after that.
    // Each interval starts on a whole tick so every clock on the page turns together.
    var speed = 0;
    function schedule(ms) {
        if (speed === ms) return;
        speed = ms;
        clearTimeout(timer);
        clearInterval(timer);
        timer = setTimeout(function () { tick(); timer = setInterval(tick, ms); }, ms - (Date.now() % ms));
    }

    function tick() {
        var now = Date.now();
        var st = NFR.phase(now);
        clocks.forEach(function (root) { render(root, st, now); });
        if (st.phase === "after") {
            document.querySelectorAll("[data-nfr-hide-after]").forEach(function (n) { n.hidden = true; });
        }
        document.documentElement.setAttribute("data-nfr-phase", st.phase);
        schedule(st.phase === "before" ? 1000 : 30e3);
    }

    NFR.initCountdowns = function () {
        document.querySelectorAll("[data-nfr-countdown]").forEach(build);
        if (clocks.length) tick();
    };

    /* ── 3. Tracking ────────────────────────────────────────────────── */
    // Clicks:      <a data-nfr-track="directions" data-nfr-label="…">
    //              nfr_placement comes from the nearest [data-nfr-placement].
    // Impressions: <section data-nfr-view="home_banner">  fires once at 50% visible.
    // Every event goes to window.dataLayer (GTM) and Shopify.analytics.publish
    // (customer-events custom pixels), so it reaches either setup unchanged.
    NFR.track = function (name, params) {
        var data = { event: name };
        Object.keys(params || {}).forEach(function (k) {
            if (params[k] !== undefined && params[k] !== null && params[k] !== "") data[k] = params[k];
        });
        (window.dataLayer = window.dataLayer || []).push(data);
        try {
            if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
                Shopify.analytics.publish(name, data);
            }
        } catch (e) { /* never let tracking break the page */ }
    };

    function context(node) {
        var p = node.closest("[data-nfr-placement]");
        return {
            nfr_placement: p ? p.getAttribute("data-nfr-placement") : "",
            nfr_phase: NFR.phase().phase,
            page_path: location.pathname
        };
    }

    document.addEventListener("click", function (e) {
        var node = e.target && e.target.closest ? e.target.closest("[data-nfr-track]") : null;
        if (!node || node.closest("[data-nfr-dragging]")) return; // a drag on a photo strip is not a click
        var c = context(node);
        NFR.track("nfr_click", {
            nfr_action: node.getAttribute("data-nfr-track"),
            nfr_label: node.getAttribute("data-nfr-label") || (node.textContent || "").replace(/\s+/g, " ").trim().slice(0, 100),
            nfr_placement: c.nfr_placement,
            nfr_phase: c.nfr_phase,
            product_handle: node.getAttribute("data-nfr-product") || "",
            link_url: node.href || "",
            page_path: c.page_path
        });
    }, true);

    NFR.watchViews = function () {
        if (!("IntersectionObserver" in window)) return;
        var nodes = document.querySelectorAll("[data-nfr-view]:not([data-nfr-seen])");
        if (!nodes.length) return;
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
                if (!en.isIntersecting) return;
                io.unobserve(en.target);
                var c = context(en.target);
                NFR.track("nfr_view", {
                    nfr_placement: en.target.getAttribute("data-nfr-view"),
                    nfr_phase: c.nfr_phase,
                    page_path: c.page_path
                });
            });
        }, { threshold: 0.5 });
        nodes.forEach(function (n) { n.setAttribute("data-nfr-seen", ""); io.observe(n); });
    };

    function init() {
        NFR.initCountdowns();
        NFR.watchViews();
    }

    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
    else init();
})();
